import { FC } from 'react';

import { ICardData, OlympiadResult } from '../../../../../types';
import InfoRow from '../components/InfoRow';

import './index.scss';

export interface IResultsTabProps {
  cardData: ICardData;
}

const renderResultSpan = (score: number, maxScore: number, bold = false) => {
  const roundedScore = score ? Math.round(score) : score;
  const roundedMaxScore = maxScore ? Math.round(maxScore) : maxScore;
  return (
    <span className={`results__span${bold ? ' results__span--bold' : ''}`}>
      {roundedScore} из {roundedMaxScore}
    </span>
  );
};

const renderResultName = (olympiadTypeCode: number, name: string) => {
  switch (olympiadTypeCode) {
    case 2: {
      return `Баллы за теорию ${name}`;
    }
    case 3: {
      return `Баллы за практику ${name}`;
    }
    default: {
      return `${name}`;
    }
  }
};

const ResultsTab: FC<IResultsTabProps> = ({ cardData }) => {
  const filteredResults = cardData.formData?.olympiadResult?.filter(
    (result: OlympiadResult) => result.olympiadTypeCode !== 1,
  );

  return (
    <div className="results">
      {cardData.name && <h4 className="results__title">{cardData.name}</h4>}
      <div className="results__list">
        <InfoRow
          name="Итоговые баллы"
          tooltip="Итоговый балл формируется по сумме туров или по формуле - проверяй правила олимпиады"
          value={renderResultSpan(cardData.formData?.result, cardData.formData?.maxScore, true)}
        />
        {filteredResults?.map((result: OlympiadResult) => (
          <InfoRow
            key={result.contestScoreId}
            name={renderResultName(result.olympiadTypeCode, result.nameContest)}
            value={renderResultSpan(result.contestScore, result.maxContestScore)}
          />
        ))}
      </div>
    </div>
  );
};

export default ResultsTab;
